import React, { useState, useEffect } from 'react';
import { Heading, Stack, Radio, RadioGroup } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const FaseTipoServicio = ({ onNext, resetReserva }) => {
  const [tipo, setTipo] = useState('');
  const [margenHoras, setMargenHoras] = useState(12); // valor por defecto
  const { t, i18n } = useTranslation();
  console.log('FaseTipoServicio idioma:', i18n.language);

  // Cargar margen de servicio programado desde el backend
  useEffect(() => {
    const cargarMargen = async () => {
      try {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
        const response = await axios.get(`${apiBaseUrl}/api/settings/public/antelacion-minima-servicio-programado`);
        if (response.data && response.data.antelacion_horas) {
          setMargenHoras(response.data.antelacion_horas);
        }
      } catch (error) {
        console.error('Error al cargar margen de servicio programado:', error);
        // Mantener valor por defecto si hay error
      }
    };
    cargarMargen();
  }, []);

  // Limpiar selección y datos de reserva cada vez que se monta el componente
  useEffect(() => {
    setTipo('');
    if (resetReserva) {
      resetReserva(); // Llamar a la función para limpiar los datos de la reserva
    }
  }, [resetReserva]);

  const handleChange = (value) => {
    setTipo(value);
    if (value === 'inmediato') {
      // Saltar a recogida y establecer hora actual UTC
      onNext({
        tipoServicio: value,
        fechaHora: new Date().toISOString(), // hora UTC actual
        skipFechaHora: true
      });
    } else if (value === 'programado') {
      onNext({ tipoServicio: value });
    }
  };

  return (
    <Stack spacing={6} align="center">
      <Heading size="md">{t('tipo_servicio_titulo')}</Heading>
      <RadioGroup onChange={handleChange} value={tipo}>
        <Stack direction="column">
          <Radio value="inmediato" isDisabled>{t('tipo_servicio_inmediato')}</Radio>
          <Radio value="programado">{t('tipo_servicio_programado', { horas: margenHoras })}</Radio>
        </Stack>
      </RadioGroup>
    </Stack>
  );
};

export default FaseTipoServicio;